import Model from "./base/model";

class CompanyCustomSetting extends Model {
  resourceName() {
    return "company_custom_settings";
  }

  fields() {
    return {
      order_list_columns: "",
      order_required_fields: "",
      iot_tab_available: "",
      request_list_columns: "",
      order_show_data: "",
      quotation_approval_percentage_value: "",
      simulation_list_columns: "",
    };
  }
}

export default new CompanyCustomSetting();
